import LoginMethodPicker from "./LoginMethodPicker";

export default LoginMethodPicker;
